module.exports = __webpack_public_path__ + "static/media/gitea.866a9aa5.svg";